import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import { thousandFormat } from 'helpers/Utility';
import React from 'react';
import PropTypes from 'prop-types';

const DrawerList = ({
  data,
  handleChangeValue,
  id,
  loanAmount,
  interestLoanInstallmentMin,
  interestLoanInstallmentMax,
  isUserLoyalty,
  isLoadingMore = false,
  showEmpty = false,
  emptyText = 'Data tidak ditemukan'
}) => {
  const primaryTextList = text => {
    if (id !== 'jobTitle' && id !== 'dailyNormalTransactions')
      return text.label;
    else return text.value;
  };

  const secondaryTextList = value => {
    if (id === 'tenure') {
      if (loanAmount > 0) {
        return isUserLoyalty === 'Y'
          ? `Rp ${thousandFormat(
              Math.round(
                ((loanAmount / value +
                  interestLoanInstallmentMin +
                  Number.EPSILON) *
                  100) /
                  100
              ),
              '.'
            )}` + ' per bulan'
          : `Rp ${thousandFormat(
              Math.round(
                ((loanAmount / value +
                  interestLoanInstallmentMin +
                  Number.EPSILON) *
                  100) /
                  100
              ),
              '.'
            )}` +
              ' - ' +
              `Rp ${thousandFormat(
                Math.round(
                  ((loanAmount / value +
                    interestLoanInstallmentMax +
                    Number.EPSILON) *
                    100) /
                    100
                ),
                '.'
              )}` +
              ' per bulan';
      } else {
        return '-';
      }
    }
  };

  const list = (
    <List key={id}>
      {showEmpty && !isLoadingMore && (
        <Box
          style={{
            textAlign: 'center',
            padding: '16px',
            fontFamily: 'Lato',
            fontSize: '14px',
            color: '#9E9E9E'
          }}
        >
          {emptyText}
        </Box>
      )}
      {data.map(text => (
        <div key={text.value}>
          <ListItem button key={text.value}>
            <ListItemText
              onClick={() => handleChangeValue(text)}
              primary={primaryTextList(text)}
              secondary={secondaryTextList(text.value)}
              style={{
                fontFamily: 'Lato',
                fontWeight: 400,
                fontSize: '14px',
                borderRadius: '16px, 16px, 0px, 0px'
              }}
            />
          </ListItem>
          <Divider />
        </div>
      ))}
      {isLoadingMore && (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '12px'
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </List>
  );

  return list;
};

DrawerList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
    })
  ).isRequired,
  emptyText: PropTypes.string,
  handleChangeValue: PropTypes.func.isRequired,
  id: PropTypes.string,
  interestLoanInstallmentMax: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  interestLoanInstallmentMin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  isLoadingMore: PropTypes.bool,
  isUserLoyalty: PropTypes.string,
  loanAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showEmpty: PropTypes.bool
};

export default DrawerList;
